import { API } from '../../Services/Api';

const request = new API();

export const getUserInfo = () => request.api.get(`/user/account/`);
